/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Competitive_2_TitleInputs */

const en_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2007 Iowa PGA Senior October Shootout Champion`)
};

const es_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campeón del Iowa PGA Senior October Shootout 2007`)
};

const de_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sieger des Iowa PGA Senior October Shootout 2007`)
};

const zh_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2007 年 Iowa PGA Senior October Shootout 冠军`)
};

const ar_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بطل Iowa PGA Senior October Shootout لعام 2007`)
};

const fr_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Champion de l’Iowa PGA Senior October Shootout 2007`)
};

const vi_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vô địch Iowa PGA Senior October Shootout 2007`)
};

const sw_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bingwa wa Iowa PGA Senior October Shootout 2007`)
};

const th_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แชมป์ Iowa PGA Senior October Shootout ปี 2007`)
};

const bs_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šampion turnira Iowa PGA Senior October Shootout 2007.`)
};

const ja_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2007年 Iowa PGA Senior October Shootout 優勝`)
};

const ko_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2007 Iowa PGA Senior October Shootout 우승`)
};

const pt_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campeão do Iowa PGA Senior October Shootout de 2007`)
};

const it_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campione dell’Iowa PGA Senior October Shootout 2007`)
};

const sv_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mästare i Iowa PGA Senior October Shootout 2007`)
};

const nl_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampioen Iowa PGA Senior October Shootout 2007`)
};

const da_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mester i Iowa PGA Senior October Shootout 2007`)
};

const nb_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mester i Iowa PGA Senior October Shootout 2007`)
};

const fi_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Senior October Shootout -turnauksen mestari 2007`)
};

const pl_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistrz Iowa PGA Senior October Shootout 2007`)
};

const ru_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чемпион турнира Iowa PGA Senior October Shootout 2007 года`)
};

const tr_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2007 Iowa PGA Senior October Shootout şampiyonu`)
};

const hi_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2007 Iowa PGA Senior October Shootout चैंपियन`)
};

const id_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara Iowa PGA Senior October Shootout 2007`)
};

const ms_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juara Iowa PGA Senior October Shootout 2007`)
};

const cs_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šampion Iowa PGA Senior October Shootout 2007`)
};

const el_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πρωταθλητής του Iowa PGA Senior October Shootout 2007`)
};

const he_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אלוף Iowa PGA Senior October Shootout לשנת 2007`)
};

const af_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampioen van die 2007 Iowa PGA Senior October Shootout`)
};

const hu_about_content_competitive_2_title = /** @type {(inputs: About_Content_Competitive_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 2007-es Iowa PGA Senior October Shootout bajnoka`)
};

/**
* | output |
* | --- |
* | "2007 Iowa PGA Senior October Shootout Champion" |
*
* @param {About_Content_Competitive_2_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_competitive_2_title = /** @type {((inputs?: About_Content_Competitive_2_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Competitive_2_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_competitive_2_title(inputs)
	if (locale === "de") return de_about_content_competitive_2_title(inputs)
	if (locale === "zh") return zh_about_content_competitive_2_title(inputs)
	if (locale === "ar") return ar_about_content_competitive_2_title(inputs)
	if (locale === "fr") return fr_about_content_competitive_2_title(inputs)
	if (locale === "vi") return vi_about_content_competitive_2_title(inputs)
	if (locale === "sw") return sw_about_content_competitive_2_title(inputs)
	if (locale === "th") return th_about_content_competitive_2_title(inputs)
	if (locale === "bs") return bs_about_content_competitive_2_title(inputs)
	if (locale === "ja") return ja_about_content_competitive_2_title(inputs)
	if (locale === "ko") return ko_about_content_competitive_2_title(inputs)
	if (locale === "pt") return pt_about_content_competitive_2_title(inputs)
	if (locale === "it") return it_about_content_competitive_2_title(inputs)
	if (locale === "sv") return sv_about_content_competitive_2_title(inputs)
	if (locale === "nl") return nl_about_content_competitive_2_title(inputs)
	if (locale === "da") return da_about_content_competitive_2_title(inputs)
	if (locale === "nb") return nb_about_content_competitive_2_title(inputs)
	if (locale === "fi") return fi_about_content_competitive_2_title(inputs)
	if (locale === "pl") return pl_about_content_competitive_2_title(inputs)
	if (locale === "ru") return ru_about_content_competitive_2_title(inputs)
	if (locale === "tr") return tr_about_content_competitive_2_title(inputs)
	if (locale === "hi") return hi_about_content_competitive_2_title(inputs)
	if (locale === "id") return id_about_content_competitive_2_title(inputs)
	if (locale === "ms") return ms_about_content_competitive_2_title(inputs)
	if (locale === "cs") return cs_about_content_competitive_2_title(inputs)
	if (locale === "el") return el_about_content_competitive_2_title(inputs)
	if (locale === "he") return he_about_content_competitive_2_title(inputs)
	if (locale === "af") return af_about_content_competitive_2_title(inputs)
	if (locale === "hu") return hu_about_content_competitive_2_title(inputs)
	return en_about_content_competitive_2_title(inputs)
});